import React from 'react';

/**
 * Generic Error SVG Icon
 */
export const GenericErrorIcon = (): JSX.Element => (
    <svg viewBox="0 0 150 150">
        <defs />
        <g id="Android-_x2F_-Light-_x2F_-illustration_x5F_generic_x5F_error">
            <linearGradient
                id="error_8_"
                x1="-217.694"
                x2="-217.0142"
                y1="488.4342"
                y2="488.5754"
                gradientTransform="matrix(51.1385 0 0 -51.0394 11219.8408 25029.4492)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#72acf1" />
                <stop offset="1" stop-color="#a7cbf6" />
            </linearGradient>
            <path
                id="error"
                fill="url(#error_8_)"
                d="M122.3 66.6L90.1 98.9c-.9.9-1.2 2.2-.9 3.4s1.3 2.1 2.5 2.5l44.1 11.7c1.2.3 2.5 0 3.4-.9.9-.9 1.2-2.2.9-3.4l-12-44.1c-.3-1.2-1.3-2.1-2.5-2.5-1.1-.3-2.4.1-3.3 1z"
            />
            <linearGradient
                id="error_9_"
                x1="-216.8405"
                x2="-217.3363"
                y1="487.8796"
                y2="488.154"
                gradientTransform="matrix(52.4588 0 0 -48.4992 11433.2275 23732.0137)"
                gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#7bddef" />
                <stop offset="1" stop-color="#c3f2f4" />
            </linearGradient>
            <path
                id="error_1_"
                fill="url(#error_9_)"
                d="M28.7 29.8l-19 41.5c-.5 1.1-.4 2.5.3 3.5s1.9 1.6 3.2 1.5L58.7 72c1.2-.1 2.3-.9 2.9-2 .5-1.1.4-2.5-.3-3.5L34.8 29.2c-.7-1-1.9-1.6-3.2-1.5s-2.3 1-2.9 2.1z"
            />
            <path
                id="error_2_"
                fill="#ffd590"
                d="M65.2 35.6L9.9 117.5c-1.5 2.2-1.7 5.1-.5 7.5s3.6 4 6.3 4.2l98.5 6.9c2.7.2 5.3-1.1 6.8-3.3 1.5-2.2 1.7-5.1.5-7.5L78.2 36.6c-1.2-2.4-3.6-4-6.3-4.2-2.6-.3-5.2 1-6.7 3.2z"
            />
            <path
                id="error_3_"
                fill="#fff"
                d="M66.4 106.9c2.3 0 4.2 1.9 4.2 4.2s-1.9 4.2-4.2 4.2c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2zm3.9-50.6c2.1.1 3.6 1.9 3.5 4l-2.7 38.3c-.1 2.1-1.9 3.6-4 3.5-2.1-.1-3.6-1.9-3.5-4l2.7-38.3c.1-2.1 1.9-3.6 4-3.5z"
            />
            <circle id="error_4_" cx="26.4" cy="64.5" r="4.2" fill="#28c2d1" />
            <path
                id="error_5_"
                fill="#3e8eed"
                d="M124 93c2.3 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2 0-2.3 1.9-4.2 4.2-4.2zm13.1-38.1c2 .6 3.1 2.7 2.5 4.7l-8.2 27c-.6 1.9-2.6 3-4.5 2.6l-.2-.1c-2-.6-3.1-2.7-2.5-4.7l8.2-27c.6-2 2.7-3.1 4.7-2.5z"
            />
            <path
                id="error_6_"
                fill="#28c2d1"
                d="M26.4 60.3c2.3 0 4.2 1.9 4.2 4.2 0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2zm-7.5-36.1l7.7 27.1c.6 2-.6 4.1-2.6 4.6s-4.1-.6-4.6-2.6l-7.7-27.1c-.6-2 .6-4.1 2.6-4.6s4 .6 4.6 2.6z"
            />
            <path
                id="error_7_"
                fill="#e1dfdd"
                d="M90.9 32.9l4.8-2.4c.5-.3 1.2-.3 1.8-.1.3.1.5.2.7.4.3.2.5.5.6.8.5 1.1.1 2.4-.9 3l-.1.1L93 37c-.5.3-1.2.3-1.7.1-.5-.2-1-.5-1.2-1l-.2-.1c-.5-1.1-.1-2.4.9-3l.1-.1 4.8-2.4-4.8 2.4zM81 25.6l2.9-4.9c.6-1 1.9-1.4 3-.9l.1.1.3.2c.8.7 1.1 1.9.6 2.8l-.1.1-2.9 4.9c-.6 1.1-2 1.4-3.1.8-.1-.1-.2-.1-.3-.2l-.1-.1-.1-.1c-.6-.7-.7-1.7-.3-2.5v-.2l2.9-4.9-2.9 4.9zM70.6 14.9c1.2-.2 2.3.6 2.6 1.8v.2l.8 6c.1.6-.1 1.2-.4 1.7-.4.5-.9.8-1.5.9-1.2.2-2.3-.6-2.6-1.8v-.1l-.8-6c-.1-.6.1-1.2.4-1.7.4-.6.9-.9 1.5-1z"
            />
        </g>
    </svg>
);
